import { env } from '@/env.js';
const nullResourceId = '000000000000000000'

const resourceIdsMap = {
    // 大家都在看
    allSeeArticle: { 
        test: {
            productId: 1435,
            productType: 13,
            resourceId: '903243720214904840',
            spmCCode: 'fd-link',
            adInfo: { "posCode": "10127", "rule": 1, "fixArray": [ 2, 7 ] } 
        },
        prod: {
            productId: 1478,
            productType: 13,
            resourceId: '903243720214904840',
            spmCCode: 'fd-link',
            adInfo: { "posCode": "10127", "rule": 1, "fixArray": [ 2, 7 ] } 
        }
    },
    // 24h热文
    hot24news: { 
        test: {
            productId: 1435,
            productType: 13,
            resourceId: '399991676964429000',
            spmCCode: 'tw',
            adInfo: {"posCode":"10489","rule":1,"fixArray":[2,5]}
        },
        prod: {
            productId: 1477,
            productType: 13,
            resourceId: '903243720214904839',
            spmCCode: 'tw',
            adInfo: {"posCode":"10123","rule":1,"fixArray":[2,5]}
        }
    },
    // 搜狐号推荐
    recommendWriter: { 
        test: {
            productId: 1435,
            productType: 13,
            resourceId: nullResourceId,
            spmCCode: 'mp',
            adInfo: {}
        },
        prod: {
            productId: 1553,
            productType: 13,
            resourceId: nullResourceId,
            spmCCode: 'mp',
            adInfo: {}
        }
    },
    // 热门精选
    hotGallery: { 
        test: {
            productId: 1435,
            productType: 13,
            resourceId: nullResourceId,
            spmCCode: 'fspic',
            adInfo: {}
        },
        prod: {
            productId: 1476,
            productType: 13,
            resourceId: nullResourceId,
            spmCCode: 'fspic',
            adInfo: {}
        }
    },
    // 焦点-猜你喜欢
    focusGuessLike: { 
        test: {
            productId: 1346,
            productType: 13,
            resourceId: '3999991687185482000',
            spmCCode: 'cnxh',
            adInfo: {"posCode":"10234","rule":1,"fixArray":[2]}
        },
        prod: {
            productId: 7196,
            productType: 13,
            resourceId: '3999991687185482000',
            spmCCode: 'cnxh',
            adInfo: {"posCode":"10351","rule":1,"fixArray":[6]}
        }
    },
    // 焦点家居-猜你喜欢
    focusHouseGuessLike: { 
        test: {
            productId: 1346,
            productType: 13,
            resourceId: '3999991700796839000',
            spmCCode: 'cnxh',
            adInfo: {"posCode":"10234","rule":1,"fixArray":[2]}
        },
        prod: {
            productId: 7196,
            productType: 13,
            resourceId: '3999991700796839000',
            spmCCode: 'cnxh',
            adInfo: {"posCode":"10583","rule":1,"fixArray":[6]}
        }
    },
    // 推荐阅读
    groomRead: { 
        test: {
            productId: 1435,
            productType: 13,
            resourceId: '903243720214904841',
            spmCCode: 'fd-d',
            adInfo: {"posCode":10224,"rule":2,"turn":5,"number":1,"begin":5}
        },
        prod: {
            productId: 1479,
            productType: 13,
            resourceId: '903243720214904841',
            spmCCode: 'fd-d',
            adInfo: {"posCode":"10122","rule":1,"fixArray":[5,10,15,20,25,30,35,40,45,50,55,60,65,70,75,80,85,90,95,99]}
        }
    },
    // 视频文章页-热门视频
    hotVideoFeed: { 
        test: {
            productId: 1435,
            productType: 13,
            resourceId: nullResourceId,
            spmCCode: 'hot-feed',
            adInfo: {}
        },
        prod: {
            productId: 1559,
            productType: 13,
            resourceId: nullResourceId,
            spmCCode: 'hot-feed',
            adInfo: {}
        }
    },
    // 视频文章页-推荐视频
    recommendVideoFeed: { 
        test: {
            productId: 1435,
            productType: 13,
            resourceId: nullResourceId,
            spmCCode: 'end-rec',
            adInfo: {}
        },
        prod: {
            productId: 1558,
            productType: 13,
            resourceId: nullResourceId,
            spmCCode: 'end-rec',
            adInfo: {}
        }
    },
    // 实验文章页-推荐阅读
    recommendFeedNa: { 
        test: {
            productId: 1435,
            productType: 13,
            resourceId: '903243720214904842',
            spmCCode: 'fd-d',
            adInfo: {"posCode":"10124","rule":2,"turn":5,"number":1,"begin":4}
        },
        prod: {
            productId: 1479,
            productType: 13,
            resourceId: '903243720214904842',
            spmCCode: 'fd-d',
            adInfo: {"posCode":"10124","rule":2,"turn":5,"number":1,"begin":4}
        }
    },
    // 实验文章页-快讯
    fastNewsNa: { 
        test: {
            productId: 1202,
            productType: 13,
            resourceId: '',
            spmCCode: 'fd-d',
            adInfo: {}
        },
        prod: {
            productId: 1554,
            productType: 13,
            resourceId: '',
            spmCCode: 'fd-d',
            adInfo: {}
        }
    },
    // 实验文章页-右侧推荐
    recommendRightNa: { 
        test: {
            ids: {
                1: {productId:1202,columnId:'',spmCCode:'recommend-tj'},//推荐
                2: {productId:1202,columnId:10242,spmCCode:'recommend-zx'}, //资讯
                3: {productId:1202,columnId:10246,spmCCode:'recommend-jj'}, //经济
                4: {productId:1202,columnId:10247,spmCCode:'recommend-ss'}, //赛事
                5: {productId:1202,columnId:10249,spmCCode:'recommend-bg'}, //八卦
                6: {productId:1202,columnId:10243,spmCCode:'recommend-jq'}, //军事
                7: {productId:1202,columnId:10265,spmCCode:'recommend-ys'}, //养生
            },
            resourceId: '903243720214904843',
            productType: 13,
            adInfo: {"posCode":"10128","rule":2,"turn":5,"number":1,"begin":4}
        },
        prod: {
            ids: {
                1: {productId:1477,columnId:'',spmCCode:'recommend-tj'},//推荐
                2: {productId:1502,columnId:10242,spmCCode:'recommend-zx'}, //资讯
                3: {productId:1502,columnId:10246,spmCCode:'recommend-jj'}, //经济
                4: {productId:1502,columnId:10247,spmCCode:'recommend-ss'}, //赛事
                5: {productId:1502,columnId:10249,spmCCode:'recommend-bg'}, //八卦
                6: {productId:1502,columnId:10243,spmCCode:'recommend-jq'}, //军事
                7: {productId:1502,columnId:10265,spmCCode:'recommend-ys'}, //养生
            },
            resourceId: '903243720214904843',
            productType: 13,
            adInfo: {"posCode":"10128","rule":2,"turn":5,"number":1,"begin":4}
        },
    },
}
// 根据senceKey获取奥丁请求参数
const getOdinResourceIdMap = (senceKey)=>{
    return resourceIdsMap?.[senceKey]?.[ env == 'test' ? 'test':'prod']
}

export {
    getOdinResourceIdMap,
    nullResourceId, // 空resourceId定义值，本意是不请求广告或返回纯流（https://www.tapd.cn/50690310/prong/stories/view/1150690310001040149）
}